var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPPTList),expression:"showPPTList"}],staticClass:"stundent-ppt-list",on:{"mouseleave":_vm.hideList}},[_c('dashTopPptList',{attrs:{"changePage":_vm.changeSPage}})],1),_c('div',{class:`shouqi ${!_vm.showPPTList && 'zhankai'}`,on:{"click":_vm.showList}})])
}
var staticRenderFns = []

export { render, staticRenderFns }